__turbopack_context__.v({
  "card": "styles-module-scss-module__CsP0wa__card",
  "card_bottom": "styles-module-scss-module__CsP0wa__card_bottom",
  "contact_link": "styles-module-scss-module__CsP0wa__contact_link",
  "office_address": "styles-module-scss-module__CsP0wa__office_address",
  "office_contact": "styles-module-scss-module__CsP0wa__office_contact",
  "office_details": "styles-module-scss-module__CsP0wa__office_details",
  "office_image": "styles-module-scss-module__CsP0wa__office_image",
  "office_name": "styles-module-scss-module__CsP0wa__office_name",
});
